module.exports = __webpack_public_path__ + "img/20.0fd3a787.webp";